const PROOF_OF_INCOME = 0;
const BANK_STATEMENT = 1;
const ELETRONIC_BANK_STATEMENT = 2;
const CONDITIONS_CALCULATION = 3;
const CONTRACT = 4;
const REGULATORY = 5;
const CELULAR_SIM_COLLATERAL = 6;
const DATA_SOURCES = 7;
const CELULAR_SIM_LIGHT_COLLATERAL = 8;
const PSYCHROMETRIC = 9;
const PSYCHROMETRIC_OR_EBS = 10;
const KNOWLEDGE_BASED_AUTHENTICATION = 12;
const EXTRA_FORMALIZATION = 20; // previous EXTRA_FORMALIZATION value = 21;
const AUTO_VERFICATION = 21;
const AUTO_DATA_MATCH = 22;
const BIOMETRY_IDENTITY = 26; // previous BIOMETRY_IDENTITY value = 20
const EMAIL_TOKEN_CLICK = 27;
const SMS_TOKEN_CLICK = 28;
const WHATSAPP_TOKEN_CLICK = 29;
const KNOX_GUARD_COLLATERAL = 31;

export const Steps = {
  PROOF_OF_INCOME,
  BANK_STATEMENT,
  ELETRONIC_BANK_STATEMENT,
  CONDITIONS_CALCULATION,
  CONTRACT,
  REGULATORY,
  CELULAR_SIM_COLLATERAL,
  DATA_SOURCES,
  CELULAR_SIM_LIGHT_COLLATERAL,
  PSYCHROMETRIC,
  PSYCHROMETRIC_OR_EBS,
  KNOWLEDGE_BASED_AUTHENTICATION,
  EXTRA_FORMALIZATION,
  AUTO_VERFICATION,
  AUTO_DATA_MATCH,
  BIOMETRY_IDENTITY,
  EMAIL_TOKEN_CLICK,
  SMS_TOKEN_CLICK,
  WHATSAPP_TOKEN_CLICK,
  KNOX_GUARD_COLLATERAL,
};

export const StepsRelatedToProofOfIncome = [
  PROOF_OF_INCOME,
  BANK_STATEMENT,
  ELETRONIC_BANK_STATEMENT,
  PSYCHROMETRIC,
  PSYCHROMETRIC_OR_EBS,
  KNOWLEDGE_BASED_AUTHENTICATION
]
